module.exports = __webpack_public_path__ + "img/Journalism07.bcb7a007.png";